import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { MODULE_ROUTES } from '../constants/module-routes.const';
import { AuthService } from '../services/auth.service';
import { IframeService } from '../services/iframe.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
  const authService = inject(AuthService);
  const iframeService = inject(IframeService);
  const router = inject(Router);

  const isLoggedIn = authService.isLoggedIn();

  if (iframeService.isIframe) {
    if (!isLoggedIn) {
      iframeService.notifyAuthRequired();
    }
  }

  if (!isLoggedIn) {
    authService.setRedirectAfterLogin(state.url);
  }

  return isLoggedIn || router.createUrlTree([MODULE_ROUTES.LOGIN]);
};
